import apiConfig from "@/configs/apiConfig";

const API_BASE_URL = apiConfig.BASE_URL;

const apiRoutes = {
  auth: {
    login: `${API_BASE_URL}/Auth/login`,
    register: `${API_BASE_URL}/Auth/register?rid=${apiConfig.RESTAURANT_ID}`,
    googleLogin: `${API_BASE_URL}/Auth/google-login?rid=${apiConfig.RESTAURANT_ID}`,
    guestLogin: `${API_BASE_URL}/Auth/guest-login?rid=${apiConfig.RESTAURANT_ID}`,
    restaurantDetails: `${API_BASE_URL}/Auth/restaurantDetails?rid=${apiConfig.RESTAURANT_ID}`,
    refreshToken: `${API_BASE_URL}/Auth/refresh-token`,
  },
  product: {
    list: `${API_BASE_URL}/MenuItem/getAllMenuItems?rid=${apiConfig.RESTAURANT_ID}`,
  },
  category: {
    list: `${API_BASE_URL}/MenuItem/getCategories?rid=${apiConfig.RESTAURANT_ID}`,
  },
  order: {
    createPaymentIntent: `${API_BASE_URL}/Orders/createPaymentIntent`,
    getAllOrdersByUserId: `${API_BASE_URL}/Orders/getAllOrdersByUserId?rid=${apiConfig.RESTAURANT_ID}`,
    calculateShipping: `${API_BASE_URL}/Orders/calculateShipping`,
    place: `${API_BASE_URL}/Orders/place?rid=${apiConfig.RESTAURANT_ID}`,
    orderQuotes: `${API_BASE_URL}/Orders/orderQuotes?rid=${apiConfig.RESTAURANT_ID}`,
    orderDetails: (id: string) =>
      `${API_BASE_URL}/Orders/orderDetails?orderId=${id}`,
    updateOrderStatus: (id: string, status: string) =>
      `${API_BASE_URL}/Orders/updateOrderStatus?orderId=${id}&status=${status}`,
    list: `${API_BASE_URL}/Orders/getAllOrders`,
  },
};

export default apiRoutes;
